<template>
  <div class="has-navbar-fixed-top">
    <!-- Top navbar -->
    <nav class="navbar is-fixed-top is-primary" role="navigation" aria-label="main navigation">
      <div class="container is-fluid">
        <div class="navbar-brand">
          <router-link to="/" class="navbar-item">
            <strong>CACFP FOOD PROGRAM</strong>
          </router-link>

          <a 
            role="button" 
            class="navbar-burger" 
            :class="{'is-active': isMenuOpen}"
            aria-label="menu" 
            aria-expanded="false" 
            @click="toggleMenu"
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </a>
        </div>

        <div class="navbar-menu" :class="{'is-active': isMenuOpen}">
          <div class="navbar-start">
            <router-link to="/" class="navbar-item">
              Dashboard
            </router-link>

            <!-- Vendor-specific navigation -->
            <template v-if="isVendorUser">
              <router-link to="/menu-items" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-restaurant"></i>
                  </span>
                  <span>Menu Items</span>
                </span>
              </router-link>
            </template>

            <!-- Regular user navigation -->
            <template v-if="!isVendorUser">
              <router-link to="/students" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-child"></i>
                  </span>
                  <span>Students</span>
                </span>
              </router-link>

              <router-link to="/sites" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-building-house"></i>
                  </span>
                  <span>Sites</span>
                </span>
              </router-link>

              <router-link to="/menus" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-food-menu"></i>
                  </span>
                  <span>Menu</span>
                </span>
              </router-link>

              <router-link to="/meal-counts" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-calculator"></i>
                  </span>
                  <span>Meal Counts</span>
                </span>
              </router-link>

              <router-link to="/meal-tally" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-list-check"></i>
                  </span>
                  <span>Meal Tally</span>
                </span>
              </router-link>

              <router-link to="/roles" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-shield-quarter"></i>
                  </span>
                  <span>Roles</span>
                </span>
              </router-link>

              <router-link to="/users" class="navbar-item">
                <span class="icon-text">
                  <span class="icon is-small mr-1">
                    <i class="bx bx-user"></i>
                  </span>
                  <span>Users</span>
                </span>
              </router-link>
            </template>
          </div>

          <div class="navbar-end">
            <div class="navbar-item has-dropdown is-hoverable">
              <a class="navbar-link">
                {{ currentUser ? currentUser.first_name : 'Account' }}
              </a>

              <div class="navbar-dropdown is-right">
                <router-link to="/account" class="navbar-item">
                  <span class="icon-text">
                    <span class="icon is-small">
                      <i class="bx bx-user-circle"></i>
                    </span>
                    <span>Account</span>
                  </span>
                </router-link>
                <router-link to="/profile" class="navbar-item">
                  <span class="icon-text">
                    <span class="icon is-small">
                      <i class="bx bx-user"></i>
                    </span>
                    <span>Profile</span>
                  </span>
                </router-link>
                <router-link to="/settings" class="navbar-item">
                  <span class="icon-text">
                    <span class="icon is-small">
                      <i class="bx bx-cog"></i>
                    </span>
                    <span>Settings</span>
                  </span>
                </router-link>
                <hr class="navbar-divider">
                <a class="navbar-item" @click="logout">
                  <span class="icon-text">
                    <span class="icon is-small">
                      <i class="bx bx-log-out"></i>
                    </span>
                    <span>Logout</span>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>

    <!-- Main content -->
    <main>
      <div class="container is-fluid py-5 mt-5">
        <router-view v-slot="{ Component }">
          <transition name="page" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </main>

    <!-- Footer -->
    <footer class="footer">
      <div class="content has-text-centered">
        <p>
          <strong>CACFP FOOD PROGRAM</strong> &copy; {{ new Date().getFullYear() }}
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MainLayout',
  data() {
    return {
      isMenuOpen: false
    }
  },
  computed: {
    ...mapGetters({
      currentUser: 'auth/currentUser'
    }),
    isVendorUser() {
      return this.currentUser && 
             (this.currentUser.user_type === 'vendor' || 
              this.currentUser.vendor_id ||
              (this.currentUser.email && this.currentUser.email.includes('@vendor.local')))
    }
  },
  methods: {
    ...mapActions({
      logoutAction: 'auth/logout'
    }),
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen
    },
    logout() {
      this.logoutAction()
    }
  }
}
</script>

<style lang="scss" scoped>
/* Fix for navbar spacing */
.has-navbar-fixed-top {
  padding-top: 3.25rem;
}

main {
  padding-top: 1rem;
}

.container.py-5 {
  padding-top: 2rem !important;
}

/* Fix footer to bottom */
.footer {
  margin-top: auto;
}
</style>
